export const recomColor = {
  textColor: '#FCFCFC',
  buttonTextColor: '#FCFCFC',
  dismissColor: '#FCFCFC',
  subTitleColor: '#919191',
  bgColor: '#4CA7ED',
};
